import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import InputMask from "react-input-mask";

import API from "../../../../actions/api-helper";
import UI from "../../../../actions/ui-helper";
import DataUtil from "../../../../actions/data";

import AuditoriaPaciente from "./AuditoriaPaciente";
import AuditoriaObservacao from "./AuditoriaObservacao";

class AuditoriaAtendimento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      versaoId: 0,
      atendimento: false,
    };
    if (this.props.match) {
      this.state.entidadeId = this.props.match.params.id;
    }
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    UI.loader("show", "Carregando histórico...");
    API.get("/historico/Atendimento/" + this.state.entidadeId)
      .then(
        (json) => {
          if (json.data.length > 0) {
            let versaoId = json.data.length - 1;
            let versao = json.data[versaoId].instancia;
            console.log(json.data);
            versao.paciente.dataNascimento = DataUtil.validarData(versao.paciente.dataNascimento) ?
              versao.paciente.dataNascimento : "";
            this.setState({ versaoId: versaoId, historico: json.data, atendimento: versao });
          }
          else {
            UI.alert(false, "Este atendimento não teve auditoria.");
          }
          UI.loader("hide");
        })
      .catch(
        (json) => {
          UI.alert(false, json.message);
          UI.loader("hide");
        });
  }

  handleChange(event) {
    let versaoId = parseInt(event.target.value);
    let versao = this.state.historico[versaoId].instancia;
    versao.paciente.dataNascimento = DataUtil.validarData(versao.paciente.dataNascimento) ?
      versao.paciente.dataNascimento : "";
    this.setState({ [event.target.name]: event.target.value, atendimento: versao });
  }

  render() {
    let styleContraste = {
      border: "1px dashed #777",
      fontWeight: "700",
      background: "#fff"
    }

    let styleSelecao = {
      border: "1px solid #777",
      borderWidth: "1px 1px 0px 1px",
      color: "rgb(0,0,150)",
      fontWeight: "700",
      background: "#ddd"
    }

    if (!this.state.atendimento) return false;
    let atendimento = this.state.atendimento;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-6 text-right">
            <select
              style={styleSelecao}
              name="versaoId"
              className="form-control"
              value={this.state.versaoId}
              onChange={this.handleChange}
            >
              {this.state.historico.map((versao, i) => {
                return (
                  <option key={i} value={i}>Versão #{i + 1} - {versao.dataHora} - {versao.usuario.nome}</option>
                );
              })}
            </select>
          </div>
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="card-title">AUDITORIA DO ATENDIMENTO #{atendimento.id}</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      onClick={() => { this.props.history.push("/atendimento/cadastro/" + atendimento.id) }}
                      className="btn btn-info">
                      <i className="fa fa-edit"></i>&nbsp;Editar
                      </button>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label>Cód / Procedimento</label>
                    <input
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="descricao"
                      className="form-control"
                      value={atendimento.procedimento.codigo + " - " + atendimento.procedimento.descricao}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label>Participantes</label>
                    <div className="badge-background">
                      {atendimento.valores.length === 0 &&
                        <div className="badge badge-none">Nenhum profissional foi selecionado...</div>}
                      {atendimento.valores.map((valor) => {
                        return (<div
                          key={valor.usuarioId}
                          className="badge badge-warning badge-remove"><i className="icon icon-user"></i>&nbsp;{valor.usuarioNome}</div>)
                      })}
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Data</label>
                    <InputMask
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="data"
                      className="form-control"
                      mask="99/99/9999"
                      value={atendimento.data}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Hora Entrada</label>
                    <InputMask
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="horaEntrada"
                      className="form-control"
                      mask="99:99"
                      value={atendimento.horaEntrada}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Hora Saída</label>
                    <InputMask
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="horaSaida"
                      className="form-control"
                      mask="99:99"
                      value={atendimento.horaSaida}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Atendimento</label>
                    <select
                      style={styleContraste}
                      disabled
                      name="tipo"
                      className="form-control"
                      value={atendimento.tipo}
                    >
                      <option value={1}>PRIMEIRA CONSULTA</option>
                      <option value={2}>RETORNO</option>
                      <option value={3}>CANCELADO</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label>Descrição</label>
                    <input
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="descricao"
                      className="form-control"
                      value={atendimento.descricao}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Estado (Atendimento)</label>
                    <input
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="estado"
                      className="form-control"
                      value={atendimento.estado}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Cidade (Atendimento)</label>
                    <input
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="cidade"
                      className="form-control"
                      value={atendimento.cidade}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AuditoriaPaciente
          paciente={atendimento.paciente}
        />
        <AuditoriaObservacao
          observacoes={atendimento.observacoes}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(AuditoriaAtendimento);